/* =========================================================
   CasaTextil
   - Rollos: precio largo ($786.000 los 262 mts a $3.000 mt)
   - No rollo (1 sola opción real = Color): agrega unidad del metafield al precio
   - No rollo con price-varies.liquid: actualiza precio de variante + unidad
   ========================================================= */

(function () {
  function isRolloProduct() {
    const titleEl =
      document.querySelector('.product__title') ||
      document.querySelector('h1') ||
      document.querySelector('[data-product-title]');

    const t = (titleEl ? titleEl.textContent : '') || '';
    const d = t.toLowerCase();
    return d.includes('x rollo') || d.includes('x rollos');
  }

  function getProductTitleText() {
    const titleEl =
      document.querySelector('.product__title') ||
      document.querySelector('h1') ||
      document.querySelector('[data-product-title]');
    return (titleEl ? titleEl.textContent : '') || '';
  }

  function toNumberFlexible(v) {
    if (v == null) return null;
    const s = String(v).trim();
    if (!s) return null;
    const n = parseFloat(s.replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  }

  function formatCOPFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    const pesos = Math.round(n / 100);

    const formatted = new Intl.NumberFormat('es-CO', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(pesos);

    return `$${formatted}`;
  }

  function getVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput || !idInput.value) return null;
    const n = Number(idInput.value);
    return Number.isFinite(n) ? n : null;
  }

  function getVariants() {
    const v = window.ShopifyAnalytics?.meta?.product?.variants;
    return Array.isArray(v) ? v : null;
  }

  // CT 2026-09-11: menor precio real (> 0) del producto, en centavos. null si ninguna variante tiene precio.
  function getMinRealPrice() {
    const vs = getVariants();
    if (!vs) return null;
    const pos = vs.map(v => Number(v.price)).filter(n => Number.isFinite(n) && n > 0);
    return pos.length ? Math.min(...pos) : null;
  }

  // CT 2026-09-11: regla "precio solo si hay algo que vender". La decide Liquid (price.liquid /
  // price-varies.liquid) y la deja en <span data-ct-regla> dentro del bloque de precio de la ficha.
  function getRules() {
    const el = document.querySelector('[id^="price-top-"] [data-ct-regla]');
    if (!el) return null;
    return {
      show: el.dataset.show === '1',
      soldOk: el.dataset.soldOk === '1',
      fallback: Number(el.dataset.fallback) > 0 ? Number(el.dataset.fallback) : null,
      avail: new Set((el.dataset.avail || '').split(',').filter(Boolean).map(Number)),
    };
  }

  // =======================
  //  ROLLOS (NO TOCAR)
  // =======================

  function ensureTopWrap() {
    let wrap = document.querySelector('[data-ct-top-rollo-price]');
    if (wrap) return wrap;

    const anchor =
      document.querySelector('.product__info-container') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!anchor) return null;

    wrap = document.createElement('div');
    wrap.setAttribute('data-ct-top-rollo-price', 'true');
    wrap.style.margin = '10px 0 14px 0';

    const line = document.createElement('div');
    line.style.fontWeight = '400';
    line.style.fontSize = '25px';
    line.style.lineHeight = '1.2';

    const span = document.createElement('span');
    span.setAttribute('data-ct-top-price-text', 'true');
    span.textContent = '';

    line.appendChild(span);
    wrap.appendChild(line);
    anchor.prepend(wrap);

    return wrap;
  }

  // CT 2026-09-19 (INP): escribir SOLO si el valor cambia. El MutationObserver de installObserver vigila todo <main>
  // (childList + attributes): reescribir el mismo texto o el mismo estilo lo volvia a disparar, y el script
  // quedaba en un bucle cada 60 ms invalidando estilos de la ficha aunque nadie la tocara.
  function ctSetText(el, v) {
    if (el.textContent !== v) el.textContent = v;
  }

  function setTopText(text) {
    const wrap = ensureTopWrap();
    if (!wrap) return;
    const el = wrap.querySelector('[data-ct-top-price-text]');
    if (!el) return;
    ctSetText(el, text || '');
  }

  function showWrap(show) {
    const wrap = document.querySelector('[data-ct-top-rollo-price]');
    if (!wrap) return;
    const ctDisp = show ? '' : 'none';
    if (wrap.style.display !== ctDisp) wrap.style.display = ctDisp;
  }

  function getUnitNameFromDOM_Rollo() {
    const dataNames = Array.from(
      document.querySelectorAll('[data-option-index] [data-name], .name-option[data-name]')
    )
      .map(el => (el.getAttribute('data-name') || '').trim())
      .filter(Boolean);

    if (dataNames.length) {
      const preferred = dataNames.find(n => /kilo|metro/i.test(n));
      if (preferred) return preferred;
      return dataNames[dataNames.length - 1];
    }

    // CT 2026-09-11: sin selector de variantes (plantilla no-tenemos) -> nombres de opción que expone
    // price-varies.liquid en data-ct-options. Solo se usa si alguno es Metros/Kilos.
    const optsEl = document.querySelector('[data-ct-top-rollo-price][data-ct-options]');
    if (optsEl) {
      const opts = (optsEl.getAttribute('data-ct-options') || '').split('|').map(s => s.trim()).filter(Boolean);
      const pref = opts.find(n => /kilo|metro/i.test(n));
      if (pref) return pref;
    }

    const textNodes = Array.from(document.querySelectorAll('legend, label, .form__label, .name-option'))
      .map(el => (el.textContent || '').trim())
      .filter(Boolean);

    const preferredText = textNodes.find(t => /^(metros|kilos)\s*:/i.test(t));
    if (preferredText) return preferredText.replace(':', '').trim();

    const any = textNodes.find(t => /:/.test(t));
    if (any) return any.replace(':', '').trim();

    return '';
  }

  function unitsFromName_Rollo(unitName) {
    const raw = (unitName || '').trim();
    const u = raw.toLowerCase();

    if (u.includes('metro')) return { qtyUnit: 'mts', rateUnit: 'mt' };
    if (u.includes('kilo')) return { qtyUnit: 'kgs', rateUnit: 'kg' };

    if (raw) return { qtyUnit: raw, rateUnit: raw };
    return { qtyUnit: '', rateUnit: '' };
  }

  function getQuantityFromVariant(variant) {
    if (!variant) return null;

    const v2 = toNumberFlexible(variant.option2);
    if (v2 && v2 > 0) return v2;

    if (Array.isArray(variant.options) && variant.options.length >= 2) {
      const n = toNumberFlexible(variant.options[1]);
      if (n && n > 0) return n;
    }

    const title = variant.public_title || variant.title || '';
    if (title) {
      const nums = String(title).match(/(\d+(?:[.,]\d+)?)/g);
      if (nums && nums.length) {
        const last = toNumberFlexible(nums[nums.length - 1]);
        if (last && last > 0) return last;
      }
    }

    return null;
  }

  function buildText_Rollo(priceCents, quantity, qtyUnit, rateUnit) {
    const totalText = formatCOPFromCents(priceCents);

    if (!quantity || quantity <= 0) {
      return `${totalText} rollo`;
    }

    const perUnitCents = Math.ceil(priceCents / quantity);
    const perUnitText = formatCOPFromCents(perUnitCents);

    if (!qtyUnit || !rateUnit) {
      return `${totalText} los ${quantity} a ${perUnitText}`;
    }

    return `${totalText} los ${quantity} ${qtyUnit} a ${perUnitText} ${rateUnit}`;
  }

  function updateTopLine_Rollo(priceCents) {
    const rollo = isRolloProduct();

    if (!rollo) {
      showWrap(false);
      setTopText('');
      return;
    }

    showWrap(true);

    const variants = getVariants();
    const variantId = getVariantId();
    if (!variants || !variantId) {
      setTopText('');
      return;
    }

    const variant = variants.find(v => Number(v.id) === Number(variantId));
    const quantity = getQuantityFromVariant(variant);

    const unitName = getUnitNameFromDOM_Rollo();
    const { qtyUnit, rateUnit } = unitsFromName_Rollo(unitName);

    // CT 2026-09-11: con regla (ficha de producto fisico): la linea larga solo para un rollo con precio que se
    // pueda comprar hoy. Si no, "Desde" el menor rollo comprable; si no hay ninguno, vacio.
    const rules = getRules();
    if (rules) {
      if (!rules.show) { setTopText(''); return; }
      const vp = variant ? Number(variant.price) || 0 : 0;
      if (vp > 0 && (rules.soldOk || rules.avail.has(Number(variant.id)))) {
        setTopText(buildText_Rollo(vp, quantity, qtyUnit, rateUnit));
      } else {
        setTopText(rules.fallback ? `Desde ${formatCOPFromCents(rules.fallback)}` : '');
      }
      return;
    }

    let p = Number(priceCents);
    if (!Number.isFinite(p) || p <= 0) {
      const vp = variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : null;
      if (!vp) {
        // CT 2026-09-11: variante sin precio (cupo de rollo a $0) -> nunca $0 ni vacio:
        // precio real mas bajo del producto. Si ninguna variante tiene precio, vacio.
        const minReal = getMinRealPrice();
        setTopText(minReal ? `Desde ${formatCOPFromCents(minReal)}` : '');
        return;
      }
      p = vp;
    }

    setTopText(buildText_Rollo(p, quantity, qtyUnit, rateUnit));
  }

  // =======================
  //  NO-ROLLO: precio variante (price-varies.liquid) + unidad
  // =======================

  function singularizePresentation(p) {
    const raw = (p || '').trim();
    if (!raw) return '';
    let s = raw.replace(/\s+/g, ' ').toLowerCase();
    if (s.endsWith('s') && s.length > 2) s = s.slice(0, -1);
    return s;
  }

  // ✅ FIX: si window.CT_PRESENTACION no existe en este template,
  // hacemos fallback con el título (Intermalla x Metros -> "metro", etc.)
  function getPresentationUnit() {
    const fromWindow = singularizePresentation(window.CT_PRESENTACION);
    if (fromWindow) return fromWindow;

    const t = getProductTitleText().toLowerCase();
    if (t.includes('x metros')) return 'metro';
    if (t.includes('x kilos')) return 'kilo';
    if (t.includes('x rollos')) return 'rollo';
    if (t.includes('x rollo')) return 'rollo';
    if (t.includes('x unidad') || t.includes('x unidades')) return 'unidad';
    if (t.includes('x tira') || t.includes('x tiras')) return 'tira';

    return '';
  }

  function updateNonRolloSelectedVariantPrice() {
    if (isRolloProduct()) return;

    const el = document.querySelector('[data-ct-selected-variant-price]');
    if (!el) return;

    const variants = getVariants();
    const variantId = getVariantId();
    if (!variants || !variantId) return;

    const v = variants.find(x => Number(x.id) === Number(variantId));
    if (!v) return;

    // CT 2026-09-11: con regla (ficha de producto fisico)
    const rules = getRules();
    if (rules) {
      const vp = Number(v.price) || 0;
      let p = null;
      if (rules.show) p = vp > 0 && (rules.soldOk || rules.avail.has(Number(v.id))) ? vp : rules.fallback;
      ctSetText(el, p ? formatCOPFromCents(p) : '');
      return;
    }
    // sin regla (otros contextos): variante a $0 -> precio real mas bajo del producto; nunca $0
    const p = Number(v.price) > 0 ? Number(v.price) : getMinRealPrice();
    ctSetText(el, p ? formatCOPFromCents(p) : '');
  }

  // ✅ FIX PRINCIPAL:
  // - Si existe el span (price-varies.liquid), lo llenamos.
  // - Si NO existe, lo creamos al lado del precio normal (product-price / price regular).
  function ensureSuffixNextToNormalPrice() {
    // 1) Si ya existe, no hacemos nada
    let suffix = document.querySelector('[data-ct-presentacion-suffix]');
    if (suffix) return suffix;

    // 2) Buscamos el nodo de precio normal (regular o "from")
    // CT 2026-09-11: SOLO dentro del bloque de precio del producto (#price-top-*). Antes buscaba en toda
    // la pagina y, si la ficha no tenia precio (no-tenemos), pegaba "metro" a una tarjeta de "Similares".
    const scope = document.querySelector('[id^="price-top-"]');
    if (!scope) return null;
    const priceNode =
      scope.querySelector('product-price .price-item--regular') ||
      scope.querySelector('.price .price-item--regular') ||
      scope.querySelector('.price-item--regular') ||
      scope.querySelector('product-price .price__from') ||
      scope.querySelector('.price .price__from') ||
      scope.querySelector('.price__from');

    if (!priceNode) return null;

    suffix = document.createElement('span');
    suffix.setAttribute('data-ct-presentacion-suffix', 'true');
    suffix.style.marginLeft = '3px';
    suffix.style.display = 'inline';
    suffix.style.fontWeight = '400';
    suffix.style.fontSize = 'inherit';
    suffix.style.lineHeight = 'inherit';

    // Insertamos justo al lado del texto del precio
    priceNode.insertAdjacentElement('afterend', suffix);
    return suffix;
  }

  function applyPresentationSuffixNonRollo() {
    if (isRolloProduct()) return;

    const unit = getPresentationUnit();
    if (!unit) return;

    const suffix = ensureSuffixNextToNormalPrice();
    if (!suffix) return;

    if (suffix.style.marginLeft !== '3px') suffix.style.marginLeft = '3px';
    // CT 2026-09-11: sin precio al lado (producto sin precio real) no se muestra la unidad sola
    const prev = suffix.previousElementSibling;
    const priceText = prev ? prev.textContent.trim() : '';
    ctSetText(suffix, priceText ? unit : '');
  }

  // =======================
  //  Timing / Observer
  // =======================

  function runAll(priceMaybe) {
    updateTopLine_Rollo(priceMaybe ?? null);
    updateNonRolloSelectedVariantPrice();
    applyPresentationSuffixNonRollo();
  }

  function scheduleInitialRetries() {
    const delays = [0, 40, 120, 250, 450, 800, 1200];
    delays.forEach(d => setTimeout(() => runAll(null), d));
  }

  function installObserver() {
    let t = null;
    const debounce = () => {
      clearTimeout(t);
      t = setTimeout(() => runAll(null), 60);
    };

    const target = document.querySelector('main') || document.body;
    if (!target) return;

    const obs = new MutationObserver(() => debounce());
    obs.observe(target, { subtree: true, childList: true, attributes: true });
  }

  function install() {
    ensureTopWrap();

    const PriceEl = customElements.get('product-price');
    if (PriceEl && PriceEl.prototype && !PriceEl.prototype.__ct_ct_hooked) {
      PriceEl.prototype.__ct_ct_hooked = true;

      const originalUpdate = PriceEl.prototype.update;
      PriceEl.prototype.update = function (price, compareAtPrice, noConvert = false) {
        originalUpdate.call(this, price, compareAtPrice, noConvert);

        setTimeout(() => runAll(price), 0);
        setTimeout(() => runAll(price), 40);
      };
    }

    document.addEventListener('change', () => runAll(null), true);
    document.addEventListener('click', () => {
      setTimeout(() => runAll(null), 0);
      setTimeout(() => runAll(null), 80);
    }, true);

    installObserver();
    scheduleInitialRetries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
  } else {
    install();
  }
})();














